// Odometer readings are written in whole kilometres grouped in thousands
// (123,456,777), the same way the worker app writes them.
const grouped = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

// A reading grouped in thousands; empty when there is none, the raw value
// when it isn't a number.
export const formatMileage = (value) => {
  if (value === null || value === undefined || `${value}`.trim() === "") return "";
  const number = Number(`${value}`.replace(/,/g, ""));
  return Number.isFinite(number) ? grouped.format(number) : `${value}`;
};

// What a mileage field holds once its commas and any stray characters are
// dropped: the bare digits, capped at nine like the app's field.
export const mileageDigits = (text) => `${text || ""}`.replace(/\D/g, "").slice(0, 9);
